// extracted by mini-css-extract-plugin
module.exports = {"primary":"css_primary__2XsW2","secondary":"css_secondary__2_c0i"};